import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import "../styles/TopNav.css";
import liluResume from "../assets/lilu-resume.pdf";

const TopNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    return (
      location.pathname === path ||
      (path === "/home" && location.pathname === "/")
    );
  };

  return (
    <Navbar expand="lg" className="topnav-custom" as="nav">
      <Navbar.Brand as={Link} to="/">
        Lilu_Codes
      </Navbar.Brand>

      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        aria-label="Toggle navigation menu"
      />

      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link
            as={Link}
            to="/home"
            aria-current={isActive("/home") ? "page" : undefined}
          >
            Home
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/about"
            aria-current={isActive("/about") ? "page" : undefined}
          >
            About
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/projects"
            aria-current={isActive("/projects") ? "page" : undefined}
          >
            Projects
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/contact"
            aria-current={isActive("/contact") ? "page" : undefined}
          >
            Contact
          </Nav.Link>
        </Nav>

        <div className="resume-button-container">
          <a
            href={liluResume}
            className="resume-button"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download my resume in PDF format (opens in new window)"
          >
            ✧ View My Resume ✧
          </a>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default TopNav;
